module.exports = __webpack_public_path__ + "media/error3.cb2d09c5.mp3";